export default __webpack_public_path__ + "static/media/arrowRight.44bea67a.svg";